import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_83nqde8ah7: FaireBrandEntity = {
  token: "b_83nqde8ah7",
  type: "brand",
  name: "Toysmith",
  avatarUrl:
    "https://cdn.faire.com/fastly/955baf1de681805d951dc04acf0ed3e0d90e46f7530cffc5eb9e788cf2df8586.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/71de1aee29d8e082042c1942d7d955b30c7af5057515f8882f835a71d22c76a4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/955baf1de681805d951dc04acf0ed3e0d90e46f7530cffc5eb9e788cf2df8586.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/71de1aee29d8e082042c1942d7d955b30c7af5057515f8882f835a71d22c76a4.png",
  location: "Pacific, WA, USA",
  minimumOrderDollars: 25,
  rating: 4.8,
  reviewCount: 2442,
  isTopShop: true,
  isInsider: true,
  description:
    "With our diverse portfolio of premium toys and gifts, we strive to turn everyday moments into joyful memories. The Toysmith story began in 1982 and for almost forty years the company has built a reputation of trust and customer service within the toy industry, manufacturing and distributing every type of high-quality toys and gifts under the rainbow. Our curated assortments cover 100% of recognized play patterns, and are proven to drive category growth.\n\nToysmith brands and products are sold to toy retailers, education markets, museums, zoos, aquariums, national parks, attractions, theme parks, gift stores, specialty catalogs and internet retailers—the more we share joy, the more it grows!\n\nToysmith is proud to present a wide array of joyful, on-trend impulse & novelty items, unique gift offerings and active play products from signature lines including Get Outside, GO™!, Beetle & Bee Garden, Snapperz™,  Prank U!™, and more. Toysmith also offers highly-effective, proven in-store merchandising solutions to support key lines including Toy Towers™ impulse items and YAY!™ rack toys.\n\nToysmith, come play with us!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:54.584Z",
    importedBy: "entity-db-cli",
  },
};
